import { GraduationCap, Home, ShieldCheck, Boxes, ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLine } from "./Reveal";
import { scrollToId } from "../hooks/useLenis";

const SERVICES = [
  {
    num: "01",
    icon: GraduationCap,
    title: "Studentflytt & utplacering",
    text: "Flyttar du via universitetet för praktik eller utplacering i annan stad? Vi skickar fakturan direkt till din skola enligt bidragsbeslutet – du betalar ingenting själv.",
    tag: "Faktura via universitet",
  },
  {
    num: "02",
    icon: Home,
    title: "Privatflytt med RUT-avdrag",
    text: "Som privatperson är du varmt välkommen. Vi hjälper familjer och individer med trygg, prisvärd flytt – med 30 % RUT-avdrag direkt på fakturan.",
    tag: "30 % RUT-avdrag",
  },
  {
    num: "03",
    icon: ShieldCheck,
    title: "Trygghet & försäkring",
    text: "Vi har ansvarsförsäkring som täcker din egendom under hela flytten och transporten. Ditt bohag är i säkra händer från dörr till dörr.",
    tag: "Ansvarsförsäkring",
  },
  {
    num: "04",
    icon: Boxes,
    title: "Bärhjälp & transport",
    text: "Behöver du extra händer? Vi hjälper med bärhjälp och transport – från studentrummet till hela familjens bohag.",
    tag: "Tillval",
  },
];

export const ServicesSection = () => (
  <section id="tjanster" data-testid="services-section" className="relative bg-[#090d16] py-24 sm:py-36 grain overflow-hidden">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16 sm:mb-20 text-center lg:text-left">
        <div>
          <Reveal>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-green-400 mb-5">Våra tjänster</p>
          </Reveal>
          <h2 className="font-display font-extrabold tracking-tight leading-[1.05] text-[clamp(1.9rem,8vw,3.75rem)] text-white">
            <MaskedLine>Fyra sätt vi</MaskedLine>
            <MaskedLine delay={0.1}>bär dig <span className="text-outline">framåt.</span></MaskedLine>
          </h2>
        </div>
        <Reveal delay={0.2}>
          <p className="text-slate-400 text-base max-w-sm mx-auto lg:mx-0 leading-relaxed">
            Från studentrummet i Umeå till familjens nya hem – samma omsorg, samma fasta pris.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1}>
            <article
              data-testid={`service-card-${s.num}`}
              className="group relative h-full border border-white/10 rounded-2xl p-8 sm:p-10 bg-white/[0.03] hover:bg-white/[0.06] hover:border-[#16a34a]/50 transition-[background-color,border-color] duration-300 flex flex-col"
            >
              <div className="flex items-start justify-between mb-10">
                <s.icon className="w-8 h-8 text-[#16a34a]" strokeWidth={1.6} />
                <span className="font-mono2 font-bold text-sm text-slate-500">{s.num}</span>
              </div>
              <h3 className="font-display font-bold text-2xl sm:text-[1.7rem] text-white tracking-tight">{s.title}</h3>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-slate-400 flex-1">{s.text}</p>
              <div className="mt-8 flex items-center justify-between">
                <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-green-400 border border-green-400/30 rounded-full px-3 py-1.5">
                  {s.tag}
                </span>
                <button
                  data-testid={`service-cta-${s.num}`}
                  onClick={() => scrollToId("#offert")}
                  aria-label={`Få offert för ${s.title}`}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-slate-300 group-hover:bg-[#16a34a] group-hover:border-[#16a34a] group-hover:text-white transition-colors duration-300"
                >
                  <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
